import { ActionType } from '../constants/ActionTypes'
export default function widgetsReducer(state = {}, action = {}) {
    switch (action.type) {
        case ActionType.GET_WIDGET_BEGIN:
            return {
                ...state,
                isLoading: true,
            }
        case ActionType.GET_WIDGET_SUCCESS:
            return {
                ...state,
                isLoading: false,
                [action.payload.id]: {
                    ...action.payload.data,
                    layoutMapping: JSON.parse(action.payload.data.layoutMapping),
                    layoutMappingMobile: JSON.parse(action.payload.data.layoutMappingMobile),
                }
            }

        case ActionType.SET_WIDGET_PREVIEW:
            return {
                ...state,
                preview: true,
                translations: JSON.parse(action.payload).translations,
                0: {
                    layoutMapping: JSON.parse(action.payload).lg,
                    layoutMappingMobile: JSON.parse(action.payload).xs,
                    isGenerated: JSON.parse(action.payload).isGenerated,
                    overlap: JSON.parse(action.payload).overlap
                }
            }
        case ActionType.SET_WIDGET_TRANSLATIONS:
            return {
                ...state,
                translations: action.payload,
            }
        case ActionType.GET_WIDGET_FOR_PREVIEW_SUCCESS:
            const {lastUpdateTime, creationTime, ...widgetPreviewObj} = action.payload.data;
            return {
                ...state,
                isLoading: false,
                [action.payload.id]: {
                    ...widgetPreviewObj,
                    layoutMapping: JSON.parse(action.payload.data.layoutMapping),
                    layoutMappingMobile: JSON.parse(action.payload.data.layoutMappingMobile)

                }
            }
        case ActionType.GET_WIDGET_ERROR:
            return {
                ...state,
                isLoading: false,
            }
        // DELETE
        // case ActionType.GET_WIDGET_TRANSLATIONS_SUCCESS:
        //     return {
        //         ...state,
        //         translations: 
        //     }
        default:
            return state;
    }

}

